import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async mainView(): Promise<types.ResMainViewList> {
        const res = {} as types.ResMainViewList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mainView", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async mainSector(): Promise<types.ResMainSector> {
        const res = {} as types.ResMainSector;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/mainSector", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async join(param: types.ReqUserForJoin): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/join", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async updatePw(param: types.ReqChangePw): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/update/pw", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async subscribe(param: types.ReqSubscribe): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/subscribe", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async idExist(id: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/id/exist/" + id, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async emailExist(email: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/email/exist/" + email, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async findId(param: types.ReqFindId): Promise<types.ResFindUserInfo> {
        const res = {} as types.ResFindUserInfo;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/find/id", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async findPw(param: types.ReqFindPw): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/find/pw", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async getBannerList(): Promise<types.ResBanner> {
        const res = {} as types.ResBanner;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/bannerList", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async getPopupBannerList(): Promise<types.ResPopupBanner> {
        const res = {} as types.ResPopupBanner;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/popup/bannerList", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async civicEngagement(): Promise<types.ResBoardForMain> {
        const res = {} as types.ResBoardForMain;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/civic/engagement", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async monitoringNews(): Promise<types.ResBoardForMain> {
        const res = {} as types.ResBoardForMain;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/monitoring/news", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async visit(): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/visit", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
